import styled from '@emotion/styled';

export const CarouselContainer = styled.div({
    containerType: 'inline-size',
    containerName: 'Carousel',
});
